import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

export default function initTemoignages(): void {
    const $carouselTemoignages = document.querySelectorAll<HTMLElement>('.js-temoignages-slider');

    $carouselTemoignages.forEach($container => {
        new CarouselTemoignages($container);
    });
}

class CarouselTemoignages {
    $el: HTMLElement;
    $slide: NodeListOf<HTMLElement>;
    $pagination: HTMLElement | null;
    mdBreakpoint: number;
    swiperMobile: Swiper | null = null;
    swiperDesktop: Swiper | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$slide = $el.querySelectorAll('.swiper-slide');
        this.$pagination = $el.querySelector('.swiper-pagination');
        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'), 10);

        this.init();
        window.addEventListener('resize', this.onResize.bind(this));
    }

    init(): void {
        this.initSlider();
    }

    initSlider(): void {
        if (window.innerWidth < this.mdBreakpoint) {
            this.initMobileSlider();
        } else {
            this.initDesktopSlider();
        }
    }

    initMobileSlider(): void {
        this.destroyDesktopSlider();
        if (this.swiperMobile) return;

        this.swiperMobile = new Swiper(this.$el, {
            modules: [Pagination],
            slidesPerView: 'auto',
            allowTouchMove: true,
            spaceBetween: 25,
            grabCursor: true,
            pagination: {
                el: this.$pagination,
            },
            autoplay: false,
        });
    }

    initDesktopSlider(): void {
        this.destroyMobileSlider();
        if (this.swiperDesktop) return;

        this.swiperDesktop = new Swiper(this.$el, {
            modules: [Pagination, Autoplay],
            slidesPerView: 'auto',
            allowTouchMove: true,
            spaceBetween: 25,
            grabCursor: true,
            pagination: {
                el: this.$pagination,
            },
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            loop: true,
            speed: 4000,
            centerInsufficientSlides: true,
            centeredSlides: true,

        });

        this.$el.addEventListener('mouseover', () => {
            if (this.swiperDesktop) {
                this.swiperDesktop.autoplay.stop();
            }
        })

        this.$el.addEventListener('mouseout', () => {
            if (this.swiperDesktop) {
                this.swiperDesktop.autoplay.start();
            }
        })
    }

    destroyMobileSlider(): void {
        if (this.swiperMobile) {
            this.swiperMobile.destroy(true, true);
            this.swiperMobile = null;
        }
    }

    destroyDesktopSlider(): void {
        if (this.swiperDesktop) {
            this.swiperDesktop.destroy(true, true);
            this.swiperDesktop = null;
        }
    }

    onResize(): void {
        if (window.innerWidth < this.mdBreakpoint) {
            this.initMobileSlider();
        } else {
            this.initDesktopSlider();
        }
    }
}
